/* v2 engine — shared interaction layer for the PRP Pure and Pharma Hermetic themes.
   No dependencies. Everything is progressive: the page works without it. */
(function () {
  'use strict';
  var d = document, root = d.documentElement, body = d.body;
  var T = window.THEME || {};
  var S = Object.assign({ cart: 'basket', Cart: 'Basket', added: 'Added to your basket', addedCartUnavailable: 'The item was added, but basket details could not be loaded.', uncertainAdd: 'We could not confirm whether the item was added. Check your basket before trying again.', viewBasket: 'View basket', unavailableVariant: 'Unavailable', error: 'Sorry, that could not be added.', remove: 'Remove', empty: 'Your basket is empty.', each: 'each' }, T.strings || {});
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var money = function (c) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: T.currency || 'GBP' }).format((c || 0) / 100); }
    catch (e) { return '£' + ((c || 0) / 100).toFixed(2); }
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var ICON = {
    minus: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10"/></svg>',
    plus: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10M8 3v10"/></svg>',
    check: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m3.5 8.5 3 3 6-7"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>'
  };

  /* ---------------- header ---------------- */
  var header = $('.site-header');
  var lastY = scrollY, ticking = false;
  function onScrollHeader() {
    var y = scrollY;
    if (header) {
      header.classList.toggle('is-scrolled', y > 24);
      var locked = root.classList.contains('menu-open') || root.classList.contains('drawer-open') || header.matches(':focus-within');
      if (!locked && y > 240 && y > lastY + 6) header.classList.add('is-hidden');
      else if (y < lastY - 6 || y < 240) header.classList.remove('is-hidden');
    }
    lastY = y; ticking = false;
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScrollHeader); } }, { passive: true });
  onScrollHeader();

  /* ---------------- desktop dropdowns ---------------- */
  $$('.nav-item').forEach(function (item) {
    var btn = item.querySelector(':scope > button'); var t;
    var open = function () { clearTimeout(t); $$('.nav-item.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); if (btn) btn.setAttribute('aria-expanded', 'true'); };
    var close = function () { t = setTimeout(function () { item.classList.remove('is-open'); if (btn) btn.setAttribute('aria-expanded', 'false'); }, 120); };
    if (fine) { item.addEventListener('mouseenter', open); item.addEventListener('mouseleave', close); }
    if (btn) btn.addEventListener('click', function () { item.classList.contains('is-open') ? (item.classList.remove('is-open'), btn.setAttribute('aria-expanded', 'false')) : open(); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
    item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('is-open'); if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); } } });
  });
  d.addEventListener('click', function (e) { if (!e.target.closest('.nav-item')) $$('.nav-item.is-open').forEach(function (o) { o.classList.remove('is-open'); }); });

  /* ---------------- mobile menu ---------------- */
  var toggle = $('.menu-toggle'), menu = $('.mobile-menu');
  function setBackgroundIsolation(active) {
    var allowed = active === menu ? [menu, toggle] : [active];
    [$('#main'), $('.site-footer'), $('.site-header .brand'), $('.site-header .nav'), $('.site-header .header-phone'), $('.site-header [data-cart-open]'), toggle, $('.fab'), menu, drawer].forEach(function (el) {
      if (!el) return;
      if (active && allowed.indexOf(el) > -1) {
        if (el && el._engineIsolation) {
          var old = el._engineIsolation;
          if ('inert' in el) el.inert = old.inert;
          if (old.hadInert) el.setAttribute('inert', ''); else el.removeAttribute('inert');
          if (old.ariaHidden == null) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', old.ariaHidden);
          delete el._engineIsolation;
        }
        return;
      }
      if (!active) {
        if (!el._engineIsolation) return;
        var old = el._engineIsolation;
        if ('inert' in el) el.inert = old.inert;
        if (old.hadInert) el.setAttribute('inert', ''); else el.removeAttribute('inert');
        if (old.ariaHidden == null) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', old.ariaHidden);
        delete el._engineIsolation;
        return;
      }
      if (!el._engineIsolation) el._engineIsolation = { inert: !!el.inert, hadInert: el.hasAttribute('inert'), ariaHidden: el.getAttribute('aria-hidden') };
      if ('inert' in el) el.inert = true;
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
    });
  }
  function setMenu(on, restoreFocus) {
    if (on && root.classList.contains('drawer-open')) closeDrawer(false);
    var wasOpen = root.classList.contains('menu-open');
    root.classList.toggle('menu-open', on);
    if (toggle) { toggle.setAttribute('aria-expanded', on); toggle.setAttribute('aria-label', on ? (T.strings && T.strings.closeMenu || 'Close menu') : (T.strings && T.strings.openMenu || 'Menu')); }
    if (menu) {
      menu.setAttribute('aria-hidden', !on);
      if ('inert' in menu) menu.inert = !on;
      if (on) {
        menu.setAttribute('role', 'dialog'); menu.setAttribute('aria-modal', 'true'); menu.setAttribute('aria-label', T.strings && T.strings.menuDialog || 'Navigation menu');
        if (!menu.hasAttribute('tabindex')) menu.setAttribute('tabindex', '-1');
      } else { menu.removeAttribute('role'); menu.removeAttribute('aria-modal'); menu.removeAttribute('aria-label'); }
    }
    if (on) setBackgroundIsolation(menu); else setBackgroundIsolation(null);
    if (on && header) header.classList.remove('is-hidden');
    if (on && menu) {
      var first = $$('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])', menu).filter(function (el) { return el.getClientRects().length > 0; })[0];
      (first || menu).focus({ preventScroll: true });
    } else if (wasOpen && restoreFocus !== false && toggle && toggle.focus) toggle.focus({ preventScroll: true });
  }
  if (menu) {
    if ('inert' in menu) menu.inert = true;
    $$('.mm-link > span, .mm-sub', menu).forEach(function (el, i) { el.style.transitionDelay = (0.12 + i * 0.045) + 's'; });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', menu).filter(function (el) { return el.getClientRects().length > 0; });
      if (!f.length) { e.preventDefault(); menu.focus({ preventScroll: true }); return; }
      var first = f[0], last = f[f.length - 1];
      if (!menu.contains(d.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  if (toggle) toggle.addEventListener('click', function () { setMenu(!root.classList.contains('menu-open')); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (root.classList.contains('menu-open')) setMenu(false); else if (root.classList.contains('drawer-open')) closeDrawer(); } });
  addEventListener('resize', function () { if (innerWidth >= 1100 && root.classList.contains('menu-open')) setMenu(false); });

  /* ---------------- split headings into words ---------------- */
  function split(el) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = d.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
            var w = d.createElement('span'); w.className = 'w';
            var inner = d.createElement('span'); inner.style.setProperty('--i', i++); inner.textContent = p;
            w.appendChild(inner); frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR' && !n.classList.contains('w')) walk(n);
      });
    })(el);
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
  }
  $$('[data-split]').forEach(split);

  /* ---------------- reveal on view ---------------- */
  $$('[data-stagger]').forEach(function (g) {
    var step = parseFloat(g.getAttribute('data-stagger')) || 0.08;
    $$(':scope > *', g).forEach(function (c, i) { if (!c.hasAttribute('data-reveal')) c.setAttribute('data-reveal', g.getAttribute('data-stagger-type') || ''); c.style.setProperty('--d', (i * step).toFixed(2) + 's'); });
  });
  var revealables = $$('[data-reveal],[data-split],[data-mask]');
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  } else revealables.forEach(function (el) { el.classList.add('is-in'); });

  /* ---------------- counters ---------------- */
  var counters = $$('[data-count]');
  if (counters.length && 'IntersectionObserver' in window && !reduced) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var el = e.target, to = parseFloat(el.getAttribute('data-count')), dec = (el.getAttribute('data-count').split('.')[1] || '').length;
        var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '', t0 = performance.now(), dur = 1600;
        (function tick(now) {
          var k = clamp((now - t0) / dur, 0, 1), eased = 1 - Math.pow(2, -10 * k);
          el.textContent = pre + (to * (k === 1 ? 1 : eased)).toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suf;
          if (k < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { c.textContent = (c.getAttribute('data-prefix') || '') + '0' + (c.getAttribute('data-suffix') || ''); cio.observe(c); });
  }

  /* ---------------- pointer effects ---------------- */
  if (fine && !reduced) {
    $$('[data-magnetic]').forEach(function (el) {
      var s = parseFloat(el.getAttribute('data-magnetic')) || 0.3;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * s).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * s * 1.2).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    $$('[data-tilt], .spot').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-tilt')) || 0, raf;
      el.addEventListener('pointermove', function (e) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          el.style.setProperty('--mx', (x * 100).toFixed(1) + '%'); el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
          if (max) { el.style.transition = 'transform .15s ease-out'; el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max).toFixed(2) + 'deg)'; }
        });
      });
      el.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); if (max) { el.style.transition = 'transform .8s cubic-bezier(.32,.72,0,1)'; el.style.transform = ''; } });
    });
  }

  /* ---------------- scrub (scroll progress → --p) + parallax ---------------- */
  var scrubs = $$('[data-scrub]'), plx = reduced ? [] : $$('[data-parallax]');
  if (scrubs.length || plx.length) {
    var active = new Set(scrubs.concat(plx)), sTick = false;
    if ('IntersectionObserver' in window) {
      active = new Set();
      var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? active.add(e.target) : active.delete(e.target); }); run(); }, { rootMargin: '20% 0px 20% 0px' });
      scrubs.concat(plx).forEach(function (el) { sio.observe(el); });
    }
    var run = function () {
      var vh = innerHeight;
      active.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (el.hasAttribute('data-scrub')) {
          var p = el.getAttribute('data-scrub') === 'sticky' ? clamp(-r.top / Math.max(1, r.height - vh), 0, 1) : clamp((vh - r.top) / (vh + r.height), 0, 1);
          if (reduced) p = 1;
          el.style.setProperty('--p', p.toFixed(4));
          if (el._p !== p) { el._p = p; el.dispatchEvent(new CustomEvent('scrub', { detail: p })); }
        }
        if (el.hasAttribute('data-parallax')) {
          var sp = parseFloat(el.getAttribute('data-parallax')) || 0.1, off = (r.top + r.height / 2 - vh / 2) * -sp;
          el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
        }
      });
      sTick = false;
    };
    addEventListener('scroll', function () { if (!sTick) { sTick = true; requestAnimationFrame(run); } }, { passive: true });
    addEventListener('resize', run);
    run();
  }

  /* ---------------- carousels ---------------- */
  $$('[data-carousel]').forEach(function (c) {
    var track = $('.car-track', c), prev = $('[data-car-prev]', c), next = $('[data-car-next]', c), bar = $('.car-progress span', c);
    if (!track) return;
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) bar.style.setProperty('--cp', max > 0 ? clamp((track.scrollLeft + track.clientWidth) / track.scrollWidth, 0.08, 1) : 1);
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    };
    var step = function (dir) { var item = track.children[0]; var w = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth * 0.8; track.scrollBy({ left: dir * w, behavior: reduced ? 'auto' : 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', update); update();
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track); // carousels inside hidden tab panels re-measure when shown
    if (fine) { // mouse drag to scroll
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
      addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5 && !moved) { moved = true; track.classList.add('is-dragging'); } if (moved) track.scrollLeft = sl - dx; });
      addEventListener('pointerup', function () { if (!down) return; down = false; if (moved) { track.classList.remove('is-dragging'); var item = track.children[0]; if (item) { var w = item.getBoundingClientRect().width + 16; track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' }); } } });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    }
  });

  /* ---------------- accordion (animated <details>) ---------------- */
  $$('.acc details').forEach(function (det) {
    var sum = $('summary', det), bodyEl = $('.acc-body', det); if (!sum || !bodyEl) return;
    sum.addEventListener('click', function (e) {
      if (reduced || !bodyEl.animate) return;
      e.preventDefault();
      var group = det.closest('[data-acc-single]');
      if (!det.open) {
        if (group) $$('details[open]', group).forEach(function (o) { if (o !== det) o.querySelector('summary').click(); });
        det.open = true; var h = bodyEl.scrollHeight;
        bodyEl.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.32,.72,0,1)' });
      } else {
        var h2 = bodyEl.scrollHeight;
        var a = bodyEl.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.65,0,.35,1)' });
        bodyEl.style.overflow = 'hidden';
        a.onfinish = function () { det.open = false; bodyEl.style.overflow = ''; };
      }
    });
    bodyEl.style.overflow = 'hidden'; requestAnimationFrame(function () { bodyEl.style.overflow = ''; });
  });

  /* ---------------- tabs (generic) ---------------- */
  $$('[data-tabs]').forEach(function (tabs) {
    var btns = $$('[role="tab"]', tabs), panels = $$('[role="tabpanel"]', tabs);
    var sel = function (b, focus) {
      btns.forEach(function (x) { var on = x === b; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p) { var on = p.id === b.getAttribute('aria-controls'); p.hidden = !on; if (on) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('tab-in'); } });
      if (focus) b.focus();
      tabs.dispatchEvent(new CustomEvent('tabchange', { detail: b, bubbles: true }));
      var ind = $('.tab-ind', tabs); if (ind) { ind.style.width = b.offsetWidth + 'px'; ind.style.transform = 'translateX(' + b.offsetLeft + 'px)'; }
    };
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { sel(b); });
      b.addEventListener('keydown', function (e) { var k = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0; if (k) { e.preventDefault(); sel(btns[(i + k + btns.length) % btns.length], true); } });
    });
    var cur = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || btns[0];
    if (cur) requestAnimationFrame(function () { sel(cur); });
    addEventListener('resize', function () { var c = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0]; if (c) sel(c); });
  });

  /* ---------------- toast ---------------- */
  var toastEl;
  function toast(msg, ok, action) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); body.appendChild(toastEl); }
    toastEl.innerHTML = (ok === false ? '' : '<i>' + ICON.check + '</i>') + '<span>' + esc(msg) + (action ? ' <a href="' + esc(action.href) + '">' + esc(action.label) + '</a>' : '') + '</span>';
    toastEl.classList.add('show'); clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }
  window.toast = toast;

  /* ---------------- cart (Shopify AJAX API) ---------------- */
  var drawer = $('#cart-drawer'), overlay = $('.overlay'), lastFocus = null, cartState = null;
  var R = Object.assign({ root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' }, T.routes || {});
  var api = function (url, opts) {
    return fetch(url, Object.assign({ headers: { Accept: 'application/json' }, credentials: 'same-origin' }, opts || {})).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || S.error); err.data = j; err.status = r.status; throw err; } return j; });
    });
  };
  function thumb(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }
  function lineHTML(it, idx) {
    var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
    var unit = it.quantity > 1 ? '<small>' + money(it.final_price) + ' ' + S.each + '</small>' : '';
    var was = it.original_line_price > it.final_line_price ? '<s class="small muted">' + money(it.original_line_price) + '</s>' : '';
    return '<div class="line" data-line="' + (idx + 1) + '" data-key="' + esc(it.key) + '">' +
      '<a class="line-img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(thumb(it.image, 240)) + '" alt="" width="120" height="120" loading="lazy">' : '') + '</a>' +
      '<div class="line-t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (opts ? '<small>' + opts + '</small>' : '') + unit +
      '<div class="qty sm" data-line-qty><button type="button" data-dec aria-label="Decrease quantity of ' + esc(it.product_title) + '">' + ICON.minus + '</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity of ' + esc(it.product_title) + '" inputmode="numeric"><button type="button" data-inc aria-label="Increase quantity of ' + esc(it.product_title) + '">' + ICON.plus + '</button></div></div>' +
      '<div class="line-p"><span>' + money(it.final_line_price) + '</span>' + was + '<button type="button" class="line-rm" data-rm>' + S.remove + '</button></div></div>';
  }
  function renderCart(cart) {
    cartState = cart;
    $$('[data-cart-count]').forEach(function (el) {
      var prev = +el.textContent || 0; el.textContent = cart.item_count; el.classList.toggle('has', cart.item_count > 0);
      if (cart.item_count > prev) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count ? '(' + cart.item_count + ')' : ''; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
    $$('[data-cart-lines]').forEach(function (box) {
      box.innerHTML = cart.items.length ? cart.items.map(lineHTML).join('') : '<div class="cart-empty">' + ICON.bag + '<p>' + S.empty + '</p><a class="btn btn-dark btn-sm" href="' + (R.all || '/collections/all') + '">' + (S.shop || 'Browse the shop') + '</a></div>';
    });
    $$('[data-cart-foot]').forEach(function (f) { f.hidden = !cart.items.length; });
  }
  function refreshCart() { return api(R.root.replace(/\/$/, '') + '/cart.js').then(renderCart).catch(function () {}); }
  function openDrawer(opener) {
    if (root.classList.contains('menu-open')) { if (!opener) opener = toggle; setMenu(false, false); }
    if (!drawer) { location.href = R.cart; return; }
    lastFocus = opener || d.activeElement;
    root.classList.add('drawer-open'); drawer.setAttribute('aria-hidden', 'false'); if ('inert' in drawer) drawer.inert = false;
    setBackgroundIsolation(drawer);
    setTimeout(function () { var f = $('.drawer-head button', drawer); if (root.classList.contains('drawer-open') && f) f.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer(restoreFocus) {
    root.classList.remove('drawer-open'); if (drawer) { drawer.setAttribute('aria-hidden', 'true'); if ('inert' in drawer) drawer.inert = true; }
    setBackgroundIsolation(null);
    var target = lastFocus; lastFocus = null;
    if (restoreFocus !== false && target && target.focus && !target.disabled && target.isConnected !== false) target.focus({ preventScroll: true });
  }
  window.openCart = openDrawer;
  if (drawer && 'inert' in drawer) drawer.inert = true;
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (!drawer || location.pathname === R.cart) return; e.preventDefault(); openDrawer(b); refreshCart(); }); });
  d.addEventListener('click', function (e) { if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); } });
  if (drawer) drawer.addEventListener('keydown', function (e) { // keep focus inside
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', drawer).filter(function (x) { return x.getClientRects().length > 0; });
    if (!f.length) { e.preventDefault(); drawer.focus({ preventScroll: true }); return; }
    var first = f[0], last = f[f.length - 1];
    if (!drawer.contains(d.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  // swipe the mobile sheet down to close
  if (drawer) {
    var sy = null, dy = 0;
    drawer.addEventListener('touchstart', function (e) { if (innerWidth >= 720) return; var inBody = e.target.closest('.drawer-body'); if (inBody && inBody.scrollTop > 0) return; sy = e.touches[0].clientY; dy = 0; }, { passive: true });
    drawer.addEventListener('touchmove', function (e) { if (sy == null) return; dy = Math.max(0, e.touches[0].clientY - sy); drawer.style.transition = 'none'; drawer.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    drawer.addEventListener('touchend', function () { if (sy == null) return; drawer.style.transition = ''; drawer.style.transform = ''; if (dy > 110) closeDrawer(); sy = null; });
  }

  var busy = false;
  function setCartBusy(on) {
    root.classList.toggle('cart-busy', on);
    $$('[data-cart-lines], [data-cart-foot]').forEach(function (el) {
      if (on) {
        if (!el._engineBusyState) el._engineBusyState = { ariaBusy: el.getAttribute('aria-busy') };
        el.setAttribute('aria-busy', 'true');
      } else if (el._engineBusyState) {
        if (el._engineBusyState.ariaBusy == null) el.removeAttribute('aria-busy');
        else el.setAttribute('aria-busy', el._engineBusyState.ariaBusy);
        delete el._engineBusyState;
      }
    });
    var controls = $$('[data-cart-lines] [data-inc], [data-cart-lines] [data-dec], [data-cart-lines] input, [data-cart-lines] [data-rm], [data-cart-foot] button[name="checkout"], [data-cart-foot] input[name="checkout"], [data-cart-foot] button[type="submit"], [data-cart-foot] input[type="submit"], [data-cart-foot] a[href*="/checkout"], #cart-update [name="update"]');
    controls.forEach(function (el) {
      if (el.matches('a[href]')) {
        if (on) {
          if (!el._engineBusyState) el._engineBusyState = { ariaDisabled: el.getAttribute('aria-disabled'), tabindex: el.getAttribute('tabindex') };
          el.setAttribute('aria-disabled', 'true'); el.setAttribute('tabindex', '-1');
        } else if (el._engineBusyState) {
          if (el._engineBusyState.ariaDisabled == null) el.removeAttribute('aria-disabled'); else el.setAttribute('aria-disabled', el._engineBusyState.ariaDisabled);
          if (el._engineBusyState.tabindex == null) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', el._engineBusyState.tabindex);
          delete el._engineBusyState;
        }
      } else if (on) {
        if (!el._engineBusyState) el._engineBusyState = { disabled: !!el.disabled };
        el.disabled = true;
      } else if (el._engineBusyState) {
        el.disabled = el._engineBusyState.disabled;
        delete el._engineBusyState;
      }
    });
  }
  function restoreCartFocus(box, key, index) {
    if (!box) return;
    var rows = $$('[data-key]', box), row = rows.filter(function (el) { return el.getAttribute('data-key') === key; })[0];
    if (!row && rows.length && index != null) row = rows[Math.min(index, rows.length - 1)];
    var target = row && ($('input', row) || $('[data-inc]', row) || $('[data-rm]', row));
    if (!target && box === drawer) target = $('.drawer-head button', drawer);
    if (!target) target = $('a[href]', box);
    if (target && target.focus) target.focus({ preventScroll: true });
  }
  d.addEventListener('submit', function (e) {
    if (busy && (e.target.id === 'cart-update' || e.target.querySelector('[name="checkout"]'))) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  d.addEventListener('click', function (e) {
    if (busy && e.target.closest('[data-cart-foot] a[href*="/checkout"]')) e.preventDefault();
  }, true);
  function changeLine(lineEl, qty) {
    if (busy || !lineEl || !lineEl.isConnected) return;
    busy = true; setCartBusy(true);
    var key = lineEl.getAttribute('data-key');
    var box = lineEl.closest('[data-cart-lines]'), rows = box ? $$('[data-key]', box) : [], index = rows.indexOf(lineEl);
    var input = $('input', lineEl), oldItem = cartState && cartState.items.filter(function (it) { return String(it.key) === key; })[0];
    var oldQty = oldItem ? oldItem.quantity : input && (parseInt(input.defaultValue, 10) || parseInt(input.value, 10) || 0);
    if (qty === 0) lineEl.classList.add('is-removing');
    lineEl.style.opacity = qty === 0 ? '' : '.55';
    api(R.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (cart) { setTimeout(function () { renderCart(cart); restoreCartFocus(box, key, index); busy = false; setCartBusy(false); }, qty === 0 ? 260 : 0); })
      .catch(function (err) {
        lineEl.classList.remove('is-removing'); lineEl.style.opacity = '';
        if (input && oldQty != null) input.value = String(oldQty);
        toast(err.message, false);
        refreshCart().then(function () { restoreCartFocus(box, key, index); busy = false; setCartBusy(false); });
      });
  }
  d.addEventListener('click', function (e) {
    var line = e.target.closest('[data-key]'); if (!line) return;
    var inp = $('input', line), q = parseInt(inp && inp.value, 10) || 0;
    if (e.target.closest('[data-inc]')) changeLine(line, q + 1);
    else if (e.target.closest('[data-dec]')) changeLine(line, Math.max(0, q - 1));
    else if (e.target.closest('[data-rm]')) { e.preventDefault(); changeLine(line, 0); }
  });
  d.addEventListener('change', function (e) { var line = e.target.closest('[data-key]'); if (line && e.target.matches('input')) changeLine(line, Math.max(0, parseInt(e.target.value, 10) || 0)); });

  var addPending = false;
  function setAddPending(on) {
    $$('[data-product-form] [type="submit"], .sticky-atc [type="submit"], [data-quick-add]').forEach(function (b) {
      if (on) { b._engineDisabledBefore = !!b.disabled; b.disabled = true; b.setAttribute('aria-busy', 'true'); }
      else { b.removeAttribute('aria-busy'); b.disabled = b.hasAttribute('data-variant-unavailable') ? b.getAttribute('data-variant-unavailable') === 'true' : !!b._engineDisabledBefore; delete b._engineDisabledBefore; }
    });
    addPending = on;
  }
  function markAddButton(btn, confirmed) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    if (confirmed) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1800); }
  }
  function addToCart(items, btn) {
    if (addPending) return Promise.resolve(false);
    addPending = true;
    if (btn) { btn.classList.remove('is-added'); btn.classList.add('is-loading'); }
    setAddPending(true);
    var postConfirmed = false;
    return api(R.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function () {
        postConfirmed = true;
        return api(R.root.replace(/\/$/, '') + '/cart.js').then(function (cart) {
          renderCart(cart); markAddButton(btn, true);
          if (drawer) setTimeout(function () { setAddPending(false); openDrawer(btn); }, btn ? 380 : 0);
          else { setAddPending(false); toast(S.added); }
        });
      })
      .catch(function (err) {
        markAddButton(btn, postConfirmed);
        setAddPending(false);
        if (postConfirmed) toast(S.addedCartUnavailable, true, { href: R.cart, label: S.viewBasket });
        else if (!err.status || err.status >= 500) toast(S.uncertainAdd, false, { href: R.cart, label: S.viewBasket });
        else toast(err.message || S.error, false);
      });
  }
  window.addToCart = addToCart;
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-product-form]'); if (!f || !window.fetch) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]');
    var btn = e.submitter && e.submitter.classList.contains('btn') ? e.submitter : f.querySelector('[type="submit"]');
    if (!id || !id.value) { e.preventDefault(); toast(S.unavailableVariant, false); return; }
    addToCart([{ id: +id.value, quantity: Math.max(1, parseInt(q && q.value, 10) || 1) }], btn);
  });
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    addToCart([{ id: +b.getAttribute('data-quick-add'), quantity: 1 }], b);
  });

  /* ---------------- quantity steppers (product form) ---------------- */
  $$('[data-qty]').forEach(function (q) {
    var inp = $('input', q);
    q.addEventListener('click', function (e) {
      var v = parseInt(inp.value, 10) || 1;
      if (e.target.closest('[data-inc]')) inp.value = v + 1;
      if (e.target.closest('[data-dec]')) inp.value = Math.max(1, v - 1);
      inp.dispatchEvent(new Event('change', { bubbles: false }));
    });
  });

  /* ---------------- product gallery + variants + sticky bar ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('.g-main', g), figs = $$('figure', main), thumbs = $$('.g-thumbs button', g), dots = $$('.g-dots span', g);
    var set = function (i) { thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j); }); dots.forEach(function (t, j) { t.classList.toggle('on', i === j); }); };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { main.scrollTo({ left: figs[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); set(i); }); });
    if ('IntersectionObserver' in window) {
      var gio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) set(figs.indexOf(e.target)); }); }, { root: main, threshold: [0.6] });
      figs.forEach(function (f) { gio.observe(f); });
    }
    g.addEventListener('gallery:go', function (e) { var i = e.detail; if (figs[i]) { main.scrollTo({ left: figs[i].offsetLeft, behavior: 'smooth' }); set(i); } });
  });
  $$('[data-product]').forEach(function (p) {
    var dataEl = $('script[data-variants]', p); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent), form = $('form[data-product-form]', p);
    var idInput = form && form.querySelector('[name="id"]');
    if (!form || !idInput) return;
    var formId = form.getAttribute('id');
    var stickyButton = formId && $$('button[form]', d).filter(function (b) { return b.getAttribute('form') === formId; })[0];
    var stickyRoot = stickyButton && stickyButton.closest('.sticky-atc');
    var stickyImage = stickyRoot && $('img', stickyRoot), initialStickyImage = stickyImage && stickyImage.getAttribute('src');
    function updateVariant(v, updateUrl) {
      var prices = $$('[data-price]', p), compares = $$('[data-compare]', p), labels = $$('[data-atc-label]', p), buttons = $$('button[type="submit"]', form);
      if (stickyRoot) { prices = prices.concat($$('[data-price]', stickyRoot)); compares = compares.concat($$('[data-compare]', stickyRoot)); }
      if (stickyButton) { buttons.push(stickyButton); labels = labels.concat($$('[data-atc-label]', stickyRoot)); }
      idInput.value = v ? v.id : '';
      idInput.setAttribute('data-sku', v && v.sku || '');
      form.setAttribute('data-variant-sku', v && v.sku || '');
      prices.forEach(function (el) { el.textContent = v ? money(v.price) : '—'; });
      compares.forEach(function (el) { var sale = v && v.compare_at_price > v.price; el.textContent = sale ? money(v.compare_at_price) : ''; el.hidden = !sale; });
      buttons.forEach(function (b) { b.setAttribute('data-variant-unavailable', !v || !v.available ? 'true' : 'false'); b.disabled = !v || !v.available || addPending; });
      labels.forEach(function (el) { el.textContent = !v ? S.unavailableVariant : (v.available ? (el.getAttribute('data-in') || el.textContent) : (el.getAttribute('data-out') || 'Sold out')); });
      if (stickyImage) stickyImage.src = v && v.image || initialStickyImage;
      if (v && v.image_index != null) { var g = $('[data-gallery]', p); if (g) g.dispatchEvent(new CustomEvent('gallery:go', { detail: v.image_index })); }
      if (updateUrl && history.replaceState) {
        var url = new URL(location.href);
        if (v) url.searchParams.set('variant', v.id); else url.searchParams.delete('variant');
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
    }
    p.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = $$('[data-option]:checked', p).map(function (i) { return i.value; });
      var v = variants.filter(function (candidate) { return candidate.options.length === chosen.length && candidate.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      updateVariant(v, true);
    });
    var initial = variants.filter(function (candidate) { return String(candidate.id) === String(idInput.value); })[0];
    updateVariant(initial, false);
  });
  var sticky = $('.sticky-atc'), anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    body.classList.add('has-sticky-atc-ready');
    var footer = $('.site-footer'), aboveAnchor = false, footerIn = false;
    var upd = function () { var on = aboveAnchor && !footerIn; sticky.classList.toggle('show', on); body.classList.toggle('has-sticky-atc', on); sticky.setAttribute('aria-hidden', !on); if ('inert' in sticky) sticky.inert = !on; };
    new IntersectionObserver(function (es) { es.forEach(function (e) { aboveAnchor = !e.isIntersecting && e.boundingClientRect.top < 0; }); upd(); }).observe(anchor);
    if (footer) new IntersectionObserver(function (es) { es.forEach(function (e) { footerIn = e.isIntersecting; }); upd(); }).observe(footer);
    upd();
  }

  /* ---------------- filter chips (animated with View Transitions when available) ---------------- */
  $$('[data-filter-group]').forEach(function (g) {
    var btns = $$('[data-filter]', g), items = $$('[data-cat]', g);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter');
        var apply = function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          items.forEach(function (it) { it.hidden = !(f === '*' || (' ' + it.getAttribute('data-cat') + ' ').indexOf(' ' + f + ' ') > -1); it.classList.add('is-in'); $$('[data-reveal]', it).forEach(function (r) { r.classList.add('is-in'); }); });
        };
        if (d.startViewTransition && !reduced) {
          items.forEach(function (it, i) { it.style.viewTransitionName = 'fi' + i; });
          var vt = d.startViewTransition(apply);
          vt.finished.then(function () { items.forEach(function (it) { it.style.viewTransitionName = ''; }); });
        } else apply();
      });
    });
  });

  /* ---------------- sort select → URL ---------------- */
  $$('[data-sort]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }); });

  /* ---------------- misc ---------------- */
  $$('[data-year]').forEach(function (el) { el.textContent = new Date().getFullYear(); });
  // keep the cart fresh when the page is restored from bfcache
  addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  if (menu) setMenu(false, false);
  if (toggle) toggle.hidden = false;
  window.__engine = true;
  root.classList.add('engine-ready');
})();
